import { Global, css } from '@emotion/react';

import React from 'react';
import { theme } from './theme';
import { tokens } from './tokens';

export const GlobalStyles: React.FC = () => (
  <Global
    styles={css`
      @import url('https://www.ikea.com/global/assets/fonts/en/fonts.css');


      :root {
        --space-xxs: 1px;
        --space-xs: 3px;
        --space-sm: 6px;
        --space-md: 12px;
        --space-lg: 16px;
        --space-xl: 24px;
        --space-xxl: 32px;
        --space-3xl: 44px;
        --line-height-tight: 1.2;
        --line-height-normal: 1.5;
        --radius-md: 4px;
        --radius-lg: 8px;
        --radius-xl: 12px;
        --pagination-footer-height: 56px;
      }

      :root.compact {
        --space-xxs: 1px;
        --space-xs: 2px;
        --space-sm: 3px;
        --space-md: 6px;
        --space-lg: 8px;
        --space-xl: 12px;
        --space-xxl: 16px;
        --space-3xl: 22px;
        --line-height-tight: 1.1;
        --line-height-normal: 1.3;
        --radius-md: 3px;
        --radius-lg: 6px;
        --radius-xl: 8px;
        --pagination-footer-height: 36px;
      }
      
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }

      html {
        font-size: ${tokens.font.size.lg};
      }

      body {
        font-family: ${tokens.font.family};
        font-size: ${tokens.font.size.md};
        line-height: ${tokens.font.lineHeight.normal};
        color: ${theme.colors.text.primary};
        background-color: ${theme.colors.bg.primary};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      input, textarea, select, button {
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
      }

      button {
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
      }

      /* Links */
      a {
        color: inherit;
        text-decoration: none;
      }

      /* Lists */
      ul, ol {
        list-style: none;
      }

      :focus-visible {
        outline: 2px solid ${theme.colors.border.focus};
        outline-offset: 2px;
      }
    `}
  />
);
